import { type PaySchedule } from 'types/payroll'

export const isPayScheduleActive = (paySchedule: PaySchedule) => {
  return (!paySchedule.end_date || new Date(paySchedule.end_date).getTime() > Date.now()) && !paySchedule.archived
}
